/* eslint-disable */
import { AxiosResponse } from 'axios';
import { IAuthAWS } from './IAuthAWS';
import { IAuthFunctionalities } from './IAuthFunctionalities';
import { ITheme } from './ITheme';

export enum AuthStatus {
  Loading,
  SignedIn,
  SignedOut,
}

export interface IAuth {
  member: {
    username: string;
    userId: string;
  };
  isAuthenticated?: boolean;
  isAnonymous?: boolean;
  useCognitoIdp?: boolean;
  sessionInfo?: {
    username?: string;
    email?: string;
    sub?: string;
    accessToken?: string;
    refreshToken?: string;
    idToken?: string;
  };
  isMultifactor?: boolean;
  globalConfig?: {
    theme?: ITheme;
    authConfig?: IAuthFunctionalities;
    config?: IAuthAWS;
  };
  passwordAdvance?: string;
  email?: string;
  stateLocation?: string;
  surname?: string;
  zip?: string;
  name?: string;
  specialty?: string;
  role?: any;
  practice?: string;
  dob?: any;
  gender?: string;
  phone?: string;
  setPhone: React.Dispatch<React.SetStateAction<string>>;
  respondToCustomChallenge?: any;
  setName: React.Dispatch<React.SetStateAction<string>>;
  setStateLocation: React.Dispatch<React.SetStateAction<string>>;
  setSurname: React.Dispatch<React.SetStateAction<string>>;
  setZip: React.Dispatch<React.SetStateAction<string>>;
  setSpecialty: React.Dispatch<React.SetStateAction<string>>;
  setPractice: React.Dispatch<React.SetStateAction<string>>;
  setRole: React.Dispatch<React.SetStateAction<any>>;
  setGender: React.Dispatch<React.SetStateAction<string>>;
  setDob: React.Dispatch<React.SetStateAction<any>>;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  setPasswordAdvance: React.Dispatch<React.SetStateAction<string>>;
  attrInfo?: any;
  authStatus?: AuthStatus;
  signInWithEmail?: any;
  signUpWithEmail?: any;
  signInOTP?: any;
  signInOTPNotRedirec?: any;
  updatePhone?: any;
  signUpWithPhone?: any;
  signOut?: any;
  verifyCode?: any;
  getSession?: any;
  sendCode?: any;
  forgotPassword?: any;
  changePassword?: any;
  getAttributes?: any;
  setAttribute?: any;
  setAttributes?: any;
  enableMFA?: any;
  disableMFA?: any;
  reSendCode?: any;
  sendCodeRecoverPassword?: any;
  sendMfaCode?: any;
  mfaRequired?: boolean;
  reSendMfaCode?: any;
  federatedSignIn?: any;
  rememberDevice?: any;
  forgotDevice?: any;
  signUpAdmin?: any;
  adminDisableUser?: any;
  adminEnableUser?: any;
  getMFAOption: () => Promise<any>;
  setMFAOption: (mfaOption: boolean) => Promise<any>;
  forgotPasswordToken?: any;
  storeData?: any;
  onChangePhoneSubmitted?: any;
  onChangeEmailSubmitted?: any;
  refreshToken?: any;
  completeNewPassword?: any;
  setIsMultifactor?: any;
  onConfirmCodeResendCodePhone?: any;
  onConfirmCodeSubmittedPhone?: any;
  onConfirmCodeSubmitted?: any;
  getCurrentUser?: any;
  cognitoRefresh?: any;
}
